import script from "./SiliconTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SiliconTable.vue?vue&type=script&setup=true&lang=js"

import "./SiliconTable.vue?vue&type=style&index=0&id=1e64f3aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e64f3aa"]])

export default __exports__